"use client";

import { authClient } from "@/lib/auth-client";
import { ConvexBetterAuthProvider } from "@convex-dev/better-auth/react";
import { ConvexReactClient } from "convex/react";
import { ThemeProvider } from "next-themes";
import React, { ReactNode } from "react";

// const convex = new ConvexReactClient(process.env.NEXT_PUBLIC_CONVEX_URL!);

export function Providers({ children }: { children: ReactNode }) {
  const [convex, setConvex] = React.useState<ConvexReactClient | null>(null);
  React.useEffect(() => {
    if (typeof window !== "undefined") {
      setConvex(new ConvexReactClient(`${window.location.origin}/api/convex`));
    }
  }, []);

  if (!convex)
    return null

  return (
    <ConvexBetterAuthProvider client={convex} authClient={authClient}>
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
        {children}
      </ThemeProvider>
    </ConvexBetterAuthProvider>
  )
}